/**
 * PM-WF-01 — the "Workflow not set" badge (project list row + project detail
 * header). A project without a workflow leaves the choice to the pilot at
 * intake (DI-D9); the badge makes the 222 undefined projects visible so each
 * gets one human decision (no silent backfill).
 */
import type { ReactElement } from "react";
import { Chip, Tooltip } from "@mui/material";

export function WorkflowNotSetChip(): ReactElement {
  return (
    <Tooltip title="No workflow defined — the pilot chooses one at intake.">
      <Chip
        size="small"
        color="warning"
        variant="outlined"
        label="Workflow not set"
        data-testid="workflow-not-set"
      />
    </Tooltip>
  );
}
